<!-- Modal -->
<template>
    <div class="modal fade" id="createRoleModal" ref="createRoleModal" tabindex="-1" aria-labelledby="createLabel" aria-hidden="true">
			<div class="modal-dialog">
				<div class="modal-content">
					<form @submit.prevent="saveRole">
						<div class="modal-header align-items-baseline">
                            <div>
                                <h5 class="modal-title" id="exampleModalLabel">Add new user role</h5>
                                <small>Here you can create new user role, and after that you can select it to manage it permissions.</small>
                            </div>
							<button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
						</div>
						<div class="modal-body">
							<div class="form-group mb-3">
								<label for="name">Name</label>
								<input type="text" v-model="role.name" placeholder="Enter role name" class="form-control" required />
							</div>
						</div>
						<div class="modal-footer">
							<button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
							<button type="submit" class="btn btn-primary">Save</button>
						</div>
					</form>
				</div>
			</div>
		</div>
</template>
<script>

import { Modal } from "bootstrap";
import juniperApi from '@/api/juniperApi'

export default {
    name: "CreateRoleModal",
    components: {
    },
    emits: ["roleSaved", "createRoleModalClosed"],
    data: () => ({
        modal: null,
        inProgress: false,
        role: {name: ''}
    }),
    mounted() {
        this.modal = new Modal(this.$refs.createRoleModal);
        
        let createRoleModal = document.getElementById("createRoleModal");
        
        let self = this;
        
        createRoleModal.addEventListener("hidden.bs.modal", function () {

            self.$emit("createRoleModalClosed");
            
            self.role = {
                name: '',
			};
        });
    },
    watch: {
        roleForChildComponent (role) {
            this.role = role;
        },
    },
    methods: {
        showModal: async function (value) {
            if (value) {
                this.modal.show();
                this.role = this.roleForChildComponent;
            }
        },
		async saveRole () {

            try {
                let res;
                if (this.update) {
                    res = await juniperApi.put(`/roles/${this.role.id}`, this.role);
                } else {
                    res = await juniperApi.post(`/roles`, this.role);
                }

                this.$swal.fire({
                    icon: 'success',
                    title: 'Role saved successfully!',
                    timer: 4000,
                });

                this.modal.hide();
                this.$emit("roleSaved", res.data.id);

            } catch (error) {
                    let message = ''
                if (error.response.data.error) {
                    for (const [key, value] of Object.entries(error.response.data.error)) {
                        console.log(key)
                        message += ` ${value} \n`
                    }
                }
                this.$swal.fire({
                    icon: 'error',
                    title: message,
                    timer: 6000,
                })
            }
		},
    },
    props: {
        update: Boolean,
        roleForChildComponent: Object
    },
};
</script>
